export default __webpack_public_path__ + "static/media/jobs_artwork.6d96c871.webp";